import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import { groupTasksService } from "../../services/admin/groupTasks.service";

export function useGroupTasksAdmin() {
  return useQuery({
    queryKey: ["admin", "group-tasks"],
    queryFn: groupTasksService.getAll,
  });
}

export function useGroupTasksByGroup(groupId?: string) {
  return useQuery({
    queryKey: ["admin", "group-tasks", groupId],
    queryFn: () => groupTasksService.getByGroup(groupId!),
    enabled: !!groupId,
  });
}

export function useSetGroupTasks() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      groupId,
      taskIds,
    }: {
      groupId: string;
      taskIds: string[];
    }) => groupTasksService.setForGroup(groupId, taskIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "group-tasks"] });
      notifications.show({
        title: "Success",
        message: "Group tasks updated successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.response?.data?.error || "Failed to update group tasks",
        color: "red",
      });
    },
  });
}
